import React, { useEffect, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as codeActions from "../../actions/codeActions";

const ContractTypeSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  codes = [],
  actions,
  placeholder,
  label
}) => {
  const [loading, setLoading] = useState(false);
  const fetchCodes = useCallback(async () => {
    setLoading(true);
    await actions.loadCodes();
    setLoading(false);
  }, [actions, setLoading]);

  useEffect(() => {
    if (!codes.length && !loading) {
      setLoading(true);
      fetchCodes();
    }
  }, [codes.length, fetchCodes, loading, setLoading]);

  const options = codes
    .filter((code) => code.entity === "Contract" && code.field === "type")
    .map((d) => ({
      label: d.value,
      value: d._id
    }));

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) => initialValue.find((i) => i.value === x.value))
      : initialValue;

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="contract-type-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        id="contract-type-select"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable
        onChange={onChange}
        isMulti={isMulti}
      />
    </React.Fragment>
  );
};

ContractTypeSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  codes: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string
};

ContractTypeSelect.defaultProps = {
  placeholder: "Contract Type"
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ContractTypeSelect);
